import { render, staticRenderFns } from "./ClickableIconMenu.vue?vue&type=template&id=05881406&scoped=true&"
import script from "./ClickableIconMenu.vue?vue&type=script&lang=ts&"
export * from "./ClickableIconMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ClickableIconMenu.vue?vue&type=style&index=0&id=05881406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05881406",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
